import { salesApiInstance } from './client.js';

export const areasApi = {
  getAll:       (params = {})       => salesApiInstance.get('/areas', { params }).then(r => r.data),
  getById:      (id)                => salesApiInstance.get(`/areas/${id}`).then(r => r.data),
  create:       (payload)           => salesApiInstance.post('/areas', payload).then(r => r.data),
  update:       (id, payload)       => salesApiInstance.put(`/areas/${id}`, payload).then(r => r.data),
  remove:       (id)                => salesApiInstance.delete(`/areas/${id}`).then(r => r.data),
  import:       (payload)           => salesApiInstance.post('/areas/import', payload).then(r => r.data),
  assignUsers:  (id, user_ids)      => salesApiInstance.put(`/areas/${id}/users`, { user_ids }).then(r => r.data),
  bulkAssign:   (area_ids, user_ids) => salesApiInstance.put('/areas/bulk-assign', { area_ids, user_ids }).then(r => r.data),
  bulkDelete:   (ids)               => salesApiInstance.post('/areas/bulk-delete', { ids }).then(r => r.data),
};

